const R = require('ramda')

const installSyncer = require('./syncer/installClient')

module.exports = () => R.pipe(
  installSyncer,
)
